enum LifeStageDateStatusEnum {
    Null = 0,
    Valid = 1,
    ValidWithExtraChar = 2,
    Invalid = 3
}

export { LifeStageDateStatusEnum };
